import logger from "../../../../utils/logger";
import { WsChangeBody } from "../../../../api/socket/WebSocketService";
import { P } from "ts-pattern";
import {
    Clear,
    Lat,
    Lon,
    RawUnitTrack,
    Timestamp,
    TrackPoint,
    UnitElementDynamic,
    UnitHashElement
} from "@context/map/units/unitsStore";
//@ts-ignore
import {Match} from "ts-pattern/dist/types/Match";
//@ts-ignore
import * as symbols from "ts-pattern/dist/internals/symbols";

const log = logger.getLogger("position.ws.handler")
const getUnitTrackPath = (unit: UnitHashElement, track: RawUnitTrack) => {
    const maxTrackPoints = 100
    const currTrack: TrackPoint[] = track.map(([lon, lat, time, clear]: [Lon, Lat, Timestamp, Clear?]) =>
        ({
            lon,
            lat,
            time,
            clear
        } as TrackPoint)
    )
    const points: TrackPoint[] = (unit.dynamic.trackPoints || [])
        .concat(currTrack)
        .reduce((points: TrackPoint[], point: TrackPoint) =>
            point.clear ? [point] : points.concat(point), [] as TrackPoint[]);

    const dropIndex = points.length - maxTrackPoints
    if (dropIndex > 0) points.splice(0, dropIndex)

    return points
}
export default function (unit: UnitHashElement) {
    return <T extends [any, any][]>(change: Match<WsChangeBody, typeof symbols.unset, T, void>) => {
        return change
            .with({
                position: P.not(P.nullish),
                azimuth: P.optional(P.number),
                track: P.optional(P.any)
            }, {rt_position: P.not(P.nullish)}, (v: Partial<UnitElementDynamic>) => {
                unit.dynamic = {
                    ...unit.dynamic,
                    ...v,
                    position: v.rt_position || v.position || unit.dynamic.position,
                    trackPoints: getUnitTrackPath(unit, v.track || [])
                }
            })
    }
}